import { useState, useEffect } from 'react';
import { getCommonAftersaleReason } from '@/api/common';
import { AftersaleReasonInfo } from '@/type/common';
import { ReasonMap } from '@/enum/afterSales';
import { history } from '@umijs/max';
export default function useQueryIndexModel() {
    const [bindingOrderNoList, setBindingOrderNoList] = useState<string[]>([]);
    const [bindingChannelOrderNoList, setBindingChannelOrderNoList] = useState<
        string[]
    >([]);

    // const [userData, setUserData] = useState<{
    //     mobile: string;
    //     orderNo: string;
    // }>({
    //     mobile: ''
    // })

    const [mobile, setMobile] = useState<string>();
    const [aftersaleReason, setAftersaleReason] =
        useState<AftersaleReasonInfo>();

    useEffect(() => {
        if (
            !history.location.pathname ||
            (history.location.pathname !== '/skip' &&
                history.location.pathname !== '/login')
        ) {
            commonAftersaleReason();
        }
    }, []);

    const commonAftersaleReason = () => {
        getCommonAftersaleReason()
            .then((res) => {
                const aftersaleReasonInfo: AftersaleReasonInfo = {};
                res.forEach((item: any) => {
                    aftersaleReasonInfo[ReasonMap[item.type]] = item.dict_items;
                });
                setAftersaleReason(aftersaleReasonInfo);
            })
            .catch((err) => {
                console.log(`CSS售后枚举查询${err}`);
            });
    };

    return {
        bindingChannelOrderNoList,
        setBindingChannelOrderNoList,
        bindingOrderNoList,
        setBindingOrderNoList,
        aftersaleReason,
        mobile,
        setMobile,
        commonAftersaleReason,
    };
}
